import { NgModule } from '@angular/core';
import { ArabicToEnglishDirective, NumberFormatInEnglishDirective, NumberFormatDirective } from './ArabicToEnglishDirective';


@NgModule({
  declarations: [
    // other shared declarations, if any
  ],
  imports: [
    ArabicToEnglishDirective,
    NumberFormatDirective,
    NumberFormatInEnglishDirective
  ],
  exports: [
    ArabicToEnglishDirective,
    NumberFormatDirective,
    NumberFormatInEnglishDirective
  ],
})
export class DirectivesSharedModule {}